import UpdateTeam from "features/teams/UpdateTeam"

    const UpdateTeamsPage = () => {
    return (
        <>
            <UpdateTeam />
            </>
    )
}

export default UpdateTeamsPage